import { FC } from 'react';
import { Header, Pagination, Segment, Table } from 'semantic-ui-react';
import Moment from 'react-moment';
import FilterAndPaginate from '@vidende/components/FilterAndPaginate';

interface QueueStatisticsWrapperProps {
    paginationOptions: any;
    paginatedItems: any;
    handlePaginationChange: any;
}

const QueueStatisticsWrapper: FC<QueueStatisticsWrapperProps> = ({
    handlePaginationChange,
    paginatedItems,
    paginationOptions,
}) => {
    return (
        <>
            {paginatedItems.length ? (
                <>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Party</Table.HeaderCell>
                                <Table.HeaderCell>Action</Table.HeaderCell>
                                <Table.HeaderCell>Created</Table.HeaderCell>
                                <Table.HeaderCell>Total</Table.HeaderCell>
                                <Table.HeaderCell>Complete</Table.HeaderCell>
                                <Table.HeaderCell>Failed</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {paginatedItems.map((item, index) => (
                                <Table.Row key={index}>
                                    <Table.Cell>{item.partyLabel}</Table.Cell>
                                    <Table.Cell>{item.actionType}</Table.Cell>
                                    <Table.Cell>
                                        <Moment>{item.createdAt}</Moment>
                                    </Table.Cell>
                                    <Table.Cell>{item.total}</Table.Cell>
                                    <Table.Cell>{item.complete}</Table.Cell>
                                    <Table.Cell>{item.failed}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    <Pagination
                        activePage={paginationOptions.activePage}
                        onPageChange={handlePaginationChange}
                        totalPages={paginationOptions.totalPages}
                    />
                </>
            ) : (
                <Segment className="row">
                    <div className="column">
                        <Header as="h3">There are no queue statistics</Header>
                    </div>
                </Segment>
            )}
        </>
    );
};

function mapOptions(props) {
    return {
        items: props.items,
        recordsPerPage: props.recordsPerPage,
    };
}

export default FilterAndPaginate(mapOptions)(QueueStatisticsWrapper);
